import { render, staticRenderFns } from "./AllowEmployeeAccessDialog.vue?vue&type=template&id=74d1c9d6&"
import script from "./AllowEmployeeAccessDialog.vue?vue&type=script&lang=js&"
export * from "./AllowEmployeeAccessDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports